import { render, staticRenderFns } from "./AccountBilling.vue?vue&type=template&id=3224e56e&scoped=true&lang=html&"
import script from "./AccountBilling.vue?vue&type=script&lang=js&"
export * from "./AccountBilling.vue?vue&type=script&lang=js&"
import style0 from "./AccountBilling.vue?vue&type=style&index=0&id=3224e56e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224e56e",
  null
  
)

export default component.exports